import styled from "styled-components";


export const Skillcard = styled.div`
overflow:hidden;
  /* display: flex; */
  flex-direction: column;
  width: 9rem;
  overflow: hidden;
  box-shadow: 0 0.1rem 1rem rgba(0, 0, 0, 0.1);
  border-radius: 1em;
  background: linear-gradient(to right, #ffffff, #ece9e6);
  @media only screen and (max-width: 1280px) {
    

  width: 5rem;

}

`;
export const SkillCardBody = styled.div`

padding: .3rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  text-align: center;
   @media only screen and (max-width: 1280px) {
    
    padding: .1rem;
  display: flex;
  flex-direction: column;
  /* gap: 0.1rem; */
  font-size:1rem;
  text-align: center; /* background: linear-gradient(to right, #ffffff, #ece9e6); */

  h4 {
  font-size: 1.5rem;
  text-transform: capitalize;
  text-align: center;
}
}
`
export const SkillCardHeader = styled.div`
justify-content: center;
  align-items: center;
  display: flex;
`
export const ProjectCard = styled.div`
  display: flex;
  flex-direction: column;
  width: clamp(30em, calc(10rem), 12rem);
  overflow: hidden;
  box-shadow: 0 0.1rem 1rem rgba(0, 0, 0, 0.1);
  border-radius: 1em;
  background: #444444;
  background: linear-gradient(to right, #ffffff, #ece9e6);
  padding: 2rem;
`
export const ProjectBody = styled.div`
  padding: .3rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  text-align: left;
  h4 {
  font-size: 1.5rem;
  text-transform: capitalize;
  text-align: center;
}

`
export const Projectfooter = styled.div`
  display: flex;
  padding: 1rem;
  margin-top: auto;
  justify-content: right;
  gap: 10px;
`

